import { createApp, h, reactive, type App } from 'vue'
import SuccessPopup from '@/components/SuccessPopup.vue'
import router from '@/router'

export interface SuccessPopupOptions {
  message: string
  title?: string
  autoClose?: boolean
  duration?: number
  route?: string
}

interface PopupState {
  visible: boolean
  message: string
  title: string
  autoClose: boolean
  duration: number
  route?: string
}

const popupState = reactive<PopupState>({
  visible: false,
  message: '',
  title: 'Success',
  autoClose: true,
  duration: 3000,
  route: undefined
})

let hostApp: App | null = null
let mountNode: HTMLDivElement | null = null

function ensureHostMounted(): void {
  if (hostApp) return

  mountNode = document.createElement('div')
  mountNode.id = 'global-success-popup-host'
  document.body.appendChild(mountNode)

  hostApp = createApp({
    setup() {
      const onClose = (): void => {
        popupState.visible = false

        if (popupState.route) {
          router.push(popupState.route)
        }

        popupState.message = ''
        popupState.title = 'Success'
        popupState.autoClose = true
        popupState.duration = 3000
        popupState.route = undefined
      }

      return () =>
        h(SuccessPopup, {
          visible: popupState.visible,
          message: popupState.message,
          title: popupState.title,
          autoClose: popupState.autoClose,
          duration: popupState.duration,
          route: popupState.route,
          onClose
        })
    }
  })

  hostApp.use(router)
  hostApp.mount(mountNode)
}

export function showSuccessPopup(options: SuccessPopupOptions): void {
  ensureHostMounted()
  popupState.message = options.message
  popupState.title = options.title ?? 'Success'
  popupState.autoClose = options.autoClose ?? true
  popupState.duration = options.duration ?? 3000
  popupState.visible = true
  popupState.route = options.route
}
